import Vue from "vue";
import * as BusEvents from "@/constants/bus-events";
import { mapGetters } from "vuex";
import * as Getters from "@/store/constants/getters";

Vue.mixin({
    data() {
        return {
            busyItems: [],
        };
    },
    computed: {
        ...mapGetters([Getters.BRAND_COLOR]),
    },
    methods: {
        data_get(object, key) {
            return _.get(object, key);
        },
        updateScroller() {
            Vue.nextTick(() => {
                window.Bus.$emit(BusEvents.UPDATE_SCROLLER);
            });
        },
        isItemBusy(item, action = null) {
            return !!this.busyItems.find(
                (i) =>
                    (typeof item === "object"
                        ? i.item == item
                        : i.item === item) && i.action === action
            );
        },
        addBusyItem(item, action = null) {
            this.busyItems.push({
                item,
                action,
            });
        },
        removeBusyItem(item, action = null) {
            let found = this.busyItems.find(
                (i) =>
                    (typeof item === "object"
                        ? i.item == item
                        : i.item === item) && action === action
            );
            if (found) {
                this.busyItems.splice(this.busyItems.indexOf(found), 1);
            }
        },
    },
});
